// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import EyeOutlinedSvg from "@ant-design/icons-svg/es/asn/EyeOutlined";
import AntdIcon from '../components/AntdIcon';

var EyeOutlined = function EyeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeOutlinedSvg
  }));
};

EyeOutlined.displayName = 'EyeOutlined';
export default React.forwardRef(EyeOutlined);